export const foreignAssetWETH = {
  id: "0xd7dee8acf39d719622ad2115fe9a82860651bd8053e7f7a6e1461f678b6caa7e",
  data: {
    icon: "/imgs/icons/foreign-asset/weth.svg",
  },
};

export const foreignAssetKSM = {
  id: "0x7c23ace0327186bf6563f6d235b382686b9b0ba82ebfb99b57f4aa9ccb30e13b",
  data: {
    icon: "/imgs/icons/foreign-asset/ksm.svg",
  },
};

export const foreignAssetETH = {
  id: "0x450c2c401f5f2eda5d93a1d083dff6af7354b7d1f09f36e6fccfb48b0693a1d3",
  data: {
    icon: "/imgs/icons/foreign-asset/eth.svg",
  },
};

export const foreignAssetLAOS = {
  id: "0x8835e1b9f588de47ec5e4a828e4e70ddb943f7ba5bd250d65b09aca35a28c358",
  data: {
    icon: "/imgs/icons/foreign-asset/laos.svg",
  },
};

export const foreignAssetAJUN = {
  id: "0xb076868f580e09ccf75e5077b6acf61a33c335e727fa93431cd92fecdd984bdc",
  data: {
    icon: "/imgs/icons/foreign-asset/ajun.svg",
  },
};

export const foreignAssetEQ = {
  id: "0xd6f6f0a4fb6d578c63a0d840e067628f57c18fb98a57f6b01e52fd0d67600bdd",
  data: {
    icon: "/imgs/icons/foreign-asset/eq.svg",
  },
};

export const foreignAssetEQD = {
  id: "0xa1086bbab0ba3cabb6d9dca709fb0cc7d565b2f6f6388433573d53d20d2f1d53",
  data: {
    icon: "/imgs/icons/foreign-asset/eqd.svg",
  },
};

export const foreignAssetGLMR = {
  id: "0xba6468a58aa39fc03d251517f3f562504693463b20a76b57f547d72a191f8d49",
  data: {
    icon: "/imgs/icons/foreign-asset/glmr.svg",
  },
};

export const foreignAssetBNC = {
  id: "0x6d97c1670a369c2b83927764bb82a8620ac042530b96c3425e37965d4cb486a2",
  data: {
    icon: "/imgs/icons/foreign-asset/bnc.svg",
  },
};

export const foreignAssetvDOT = {
  id: "0xbf9a89eb4d39bc13d81d97dfe3b7e1150b9a38fd55337198d86b24a2dc4126cd",
  data: {
    icon: "/imgs/icons/foreign-asset/vdot.svg",
  },
};

export const foreignAssetDOT = {
  id: "0x8080778c30c20fa2ebc0ed18d2cbca1f30b027625c7d9d97f5d589721c91aeb6",
  data: {
    icon: "/imgs/icons/foreign-asset/dot.svg",
  },
};

export const foreignAssetHDX = {
  id: "0xcc3fe7214349eb24f08de9da4dc45d34172e0b178be1dee0bf158f0453dcc3f9",
  data: {
    icon: "/imgs/icons/foreign-asset/hdx.svg",
  },
};

export const foreignAssetTEER = {
  id: "0x02ee13523947f1d649f98e27960756a561ade4ca14e2393b31980259358e6079",
  data: {
    icon: "/imgs/icons/foreign-asset/teer.svg",
  },
};

export const foreignAssetPLMC = {
  id: "0xf6c47869c52b0ad966796d539779f9e3d66a5e2f12052783f531c889a1edbf6c",
  data: {
    icon: "/imgs/icons/foreign-asset/plmc.svg",
  },
};

export const foreignAssetUSDt = {
  id: "0x1dcdcb91b148cd7512fd82d006fb09ea55fcfe46b062c819f84e5cb19a04f69b",
  data: {
    icon: "/imgs/icons/foreign-asset/usdt.svg",
  },
};

export const foreignAssetUSDC = {
  id: "0x7dadc06a974252e2a81cf01a760b2b7dc3656ae8ea7f78a03e55bb72771a0032",
  data: {
    icon: "/imgs/icons/foreign-asset/usdc.svg",
  },
};

export const foreignAssetMYTH = {
  id: "0xc02be98ea7f8df54d43659c09e3b0088d3cc5f4fc400306fa210a7584ba2a421",
  data: {
    icon: "/imgs/icons/asset/myth.svg",
  },
};
